import * as angular from "angular";
import * as _ from "lodash";

import { ModelBase, BaseModel, modelModule } from "./model";
import ITaggingKeyword = model.ITaggingKeyword;
import IGeoSpaCashflowSearchCriteria = model.IGeoSpaCashflowSearchCriteria;
import IAdvancedSearchCriteria = model.IAdvancedSearchCriteria;
import ITaggedEntitiesSearchResult = model.ITaggedEntitiesSearchResult;
import ISubscriber = model.ISubscriber;
import IQuickSearch = model.IQuickSearch;
import { BVUtils } from "../BVUtils";

export class AssetsModel extends ModelBase {
    private selectedAssetIDCacheKey: string;
    private selectedAssetIDCache: number;
    private app_context_key = 'app_contexts';
    private app_context_adhoc_key = 'app_contexts_adhoc';
    constructor($http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService, public baseModel: BaseModel) {
        super("api/Assets/", $http, $q, $log, baseModel);

        this.selectedAssetIDCacheKey = "selectedAssetIDCacheKey";
        this.selectedAssetIDCache = parseInt(this.baseModel.storage[this.selectedAssetIDCacheKey]);
    }

    private rootNodeID: number = -1;

    private assetDictionary: { [id: number]: model.IAsset } = {};
    private childrenDictionary: { [id: number]: model.IAsset[] } = {};

    public clearAssetCaches() {
        this.assetDictionary = {};
        this.childrenDictionary = {};
    }

    private populateAssetTreeCacheKey = 'populateAssetTreeCacheKey';
    private getPopulateAssetTreeCacheKey(root: string, startAtLevel: string, stopLevel: string, selectedAsset: string, appContext: string) {
        let key = this.populateAssetTreeCacheKey + "_" + root + "_" + startAtLevel + "_" + stopLevel + "_" + selectedAsset + "_" + appContext;
        return key;
    }
    public clearPopulateAssetTreeCache() {
        this.baseModel.clearCacheKeyContaining(this.populateAssetTreeCacheKey)
    }

    private advancedSearchCacheKey: string = 'advancedSearchCacheKey';
    public clearAdvancedSearchCache() {
        this.baseModel.clearCacheKeyContaining(this.advancedSearchCacheKey)
    }
    private getAdvancedSearchCacheKey(searchCriteria: model.IAdvancedSearchCriteria, pageSize?: number) {
        let page: string = pageSize ? pageSize.toString() : '';
        let key = this.advancedSearchCacheKey + "_" + page + "_" + JSON.stringify(searchCriteria,null,0);
        return key;
    }

    private savedAsset: number = 0;

    private sortAssets(assetList: model.IAsset[]) {
        assetList.sort((a: model.IAsset, b: model.IAsset) => {
            var result = 0;
            if (a.DisplayOrder === b.DisplayOrder) {
                result = a.AssetID > b.AssetID ? 1 : (a.AssetID < b.AssetID ? -1 : 0);
            }
            else {
                result = a.DisplayOrder - b.DisplayOrder;
            }
            return result;
        });
        return assetList;
    }

    public clearAppContextsCache() {
        delete this.baseModel.storage[this.app_context_key]
        delete this.baseModel.storage[this.app_context_adhoc_key]
    }

    public getAppContexts() {
        var deferred: ng.IDeferred<model.IAppContext[]> = this.$q.defer();

        if (angular.isDefined(this.baseModel.storage[this.app_context_key]) && angular.fromJson(this.baseModel.storage[this.app_context_key]).length > 0) {
            deferred.resolve(angular.fromJson(this.baseModel.storage[this.app_context_key]));
        }
        else {
            this.$http.get<model.IAppContext[]>(this.GetUrl("AppContexts"))
                .then((data) => {
                    this.baseModel.storage[this.app_context_key] = angular.toJson(data.data);
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAppContexts", err.data);
                    deferred.reject(err.data);
                });
        }

        return deferred.promise;
    }

    public getAppContextsAdHocNavReady() {
        var deferred: ng.IDeferred<model.IAppContext[]> = this.$q.defer();

        if (angular.isDefined(this.baseModel.storage[this.app_context_adhoc_key]) && angular.fromJson(this.baseModel.storage[this.app_context_adhoc_key]).length > 0) {
            deferred.resolve(angular.fromJson(this.baseModel.storage[this.app_context_adhoc_key]));
        }
        else {
            this.$http.get<model.IAppContext[]>(this.GetUrl("AppContextsAdHocNav"))
                .then((data) => {
                    this.baseModel.storage[this.app_context_adhoc_key] = angular.toJson(data.data);
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAppContextsAdHocNav", err.data);
                    deferred.reject(err.data);
                });
        }

        return deferred.promise;
    }

    public getAppContextsAndProcess() {
        return this.getAppContexts()
            .then((myACs) => {

                let acDict: { [id: string]: boolean } = {};

                //I am adding this section of code so that we can create app contexts that limit access to apps but that don't show
                //up in the app tray.  The user would have to know the address of the app to get to it.  
                //This section also makes sure that the app contexts are unique.
                var appContextsWithTargets: model.IAppContext[] = [];
                for (var i = 0; i < myACs.length; i++) {
                    if (myACs[i].Path) {
                        if (!acDict[myACs[i].DisplayName]) {
                            appContextsWithTargets.push(myACs[i]);
                            acDict[myACs[i].DisplayName] = true;
                        }
                    }

                }
                myACs = appContextsWithTargets;
                myACs.sort((a: model.IAppContext, b: model.IAppContext) => {
                    return a.DisplayOrder - b.DisplayOrder;
                });
                return myACs;
            });

    }

    public getAssetViews(assetID: number, applicationContext: string) {
        var deferred: ng.IDeferred<model.IAssetViews> = this.$q.defer();

        this.$http.get<model.IAssetViews>(this.GetUrl("AssetViews"),
            { 'params': { 'assetId': assetID, 'applicationContext': applicationContext } })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetViews", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    public selectView(assetID: number, viewID: number) {
        var deferred = this.$q.defer();

        //If this is cal
        if (assetID !== null && assetID !== undefined && viewID !== null && viewID !== undefined) {
            this.$http.get(this.GetUrl("SelectAssetView"), { 'params': { 'asset': assetID, 'view': viewID } })
                .then((data) => {
                    deferred.resolve(data);
                })
                .catch((err) => {
                    var result = "Unable to select an asset view ";
                    if (angular.isString(err.data)) { result += err.data; }
                    else if (err.data) {
                        result += err.data.message || err.data.Message || err.data;
                    }
                    this.LogError("selectView", err.data);
                    deferred.reject(result);
                });
        }
        else {
            deferred.resolve(null);
        }

        return deferred.promise;
    }

    public getUserAdminAssets() {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        this.$http.get<model.IAsset[]>(this.GetUrl("UserAdminAssets"))
            .then((data) => {
                // sort order of siblings is DisplayOrder then AssetID  
                deferred.resolve(this.sortAssets(data.data));
            })
            .catch((err) => {
                this.LogError("getUserAdminAssets", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }



    public getFirstChildrenOfType(assetID: number, typeID?: number, appContextID?: number) {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();
        if (appContextID == null) {
            appContextID = undefined;
        }

        if (!angular.isNumber(assetID) || assetID <= 0) {
            assetID = this.rootNodeID;
        }

        this.$http.get<model.IAsset[]>(this.GetUrl("FirstChildrenOfType"),
            { 'params': { 'typeID': typeID, 'rootID': assetID, 'appContextID': appContextID } })
            .then((data) => {

                // sort order of siblings is DisplayOrder then AssetID    
                data.data = this.sortAssets(data.data);

                //This line ensures that the root nodes will have their parent set to rootNodeID.
                if (assetID === this.rootNodeID) {
                    for (var p of data.data) {
                        p.ParentAssetID = this.rootNodeID;
                    }
                }

                //Add these assets to the asset dictionary, no reason to get them again. 
                if (angular.isUndefined(appContextID)) {
                    for (var p of data.data) {
                        this.assetDictionary[p.AssetID] = angular.copy(p);
                    }
                }

                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getFirstChildrenOfType", err.data);
                deferred.reject(err.data);
            });


        return deferred.promise;
    };



    public clearChildrenDictionary(assetID?: number) {
        if (assetID === undefined) {
            this.childrenDictionary = {};
        }
        else {
            delete this.childrenDictionary[assetID];
        }
    }

    public getAssetChildren(assetID: number, appContextID?: string | number, getAllEntities?: boolean) {
        var assetChildrenDeferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();
        if (appContextID == null) {
            appContextID = undefined;
        }

        var myAppContextName: string = null;
        var myAppContextID: number = null;
        if (angular.isDefined(appContextID)) {
            if (typeof appContextID == "string") {
                myAppContextName = <string>appContextID;
            }
            else if (typeof appContextID == "number") {
                myAppContextID = <number>appContextID;
            }
        }

        var myGetAllEntities: boolean = false;
        if (getAllEntities) {
            myGetAllEntities = getAllEntities;
        }

        //If the assetID parameter is falsy then assume the caller wants the root nodes. 
        if (!assetID) {
            assetID = this.rootNodeID;
        }

        //Check the dictionary for the kids.  If the kids are there, return immediately. 
        var kids = this.childrenDictionary[assetID];

        //Don't want to respect the cache if the app context ID is set. 
        if (angular.isUndefined(appContextID) && kids) {
            assetChildrenDeferred.resolve(angular.copy(kids));
        }
        else {

            //Get the assets from the service.
            this.$http.get<model.IAsset[]>(this.GetUrl("Children"),
                {
                    'params': {
                        'Id': assetID, 'appContextID': myAppContextID, 'appContextName': myAppContextName, 'getAllEntities': myGetAllEntities
                    }
                })
                .then((allData) => {

                    let data = this.sortAssets(allData.data);

                    //This line ensures that the root nodes will have their parent set to rootNodeID.
                    if (assetID === this.rootNodeID) {
                        for (var p of data) {
                            p.ParentAssetID = this.rootNodeID;
                        }
                    }

                    //This check exists so that if the assets were added to the dictionary before this call they will
                    //be used from the dictionary rather than the service. 
                    if (angular.isUndefined(appContextID)) {
                        if (!this.childrenDictionary[assetID]) {
                            this.childrenDictionary[assetID] = angular.copy(data);
                            for (var p of data) {
                                this.assetDictionary[p.AssetID] = angular.copy(p);
                            }
                        }
                        else {
                            data = angular.copy(this.childrenDictionary[assetID]);
                        }
                    }


                    assetChildrenDeferred.resolve(data);
                })
                .catch((err) => {
                    var result = "Failed to retrieve asset children ";
                    if (angular.isString(err.data)) {
                        result = result + err.data;
                    }
                    else if (err.data) {
                        result = result + (err.data.message || err.data.Message);
                    }
                    this.LogError("getAssetChildren", err.data);
                    assetChildrenDeferred.reject(result);
                });
        }

        return assetChildrenDeferred.promise;
    };

    public hasRightsToAllDescendants(assetId: number) {
        var hasRightsToAllDescendantsDeferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl("HasRightsToAllDescendants"), { 'params': { 'assetId': assetId } })
            .then((data) => {
                hasRightsToAllDescendantsDeferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("hasRightsToAllDescendants", err.data);
                hasRightsToAllDescendantsDeferred.reject(err.data);
            });

        return hasRightsToAllDescendantsDeferred.promise;
    }

    public getSensorsForAssets(assets: number[]) {
        var sensorsDeferred: ng.IDeferred<model.IAssetVariableTypeTagMap[]> = this.$q.defer();

        this.$http.get<model.IAssetVariableTypeTagMap[]>(this.GetUrl("GetSensorsForAssets"), { 'params': { 'assetID': assets } })
            .then((data) => {
                sensorsDeferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getSensorsForAssets", err.data);
                sensorsDeferred.reject(err.data);
            });

        return sensorsDeferred.promise;
    }

    public getAssetChildrenWithSensors(assetID?: number, appContextId?: number) {
        var assetChildrenDeferred: ng.IDeferred<model.IChildrenAndSensors> = this.$q.defer();

        this.$http.get<model.IChildrenAndSensors>(this.GetUrl("ChildrenWithSensors"),
            { 'params': { 'assetID': assetID, 'appContextId': appContextId } })
            .then((data) => {
                assetChildrenDeferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetChildrenWithSensors", err.data);
                assetChildrenDeferred.reject(err.data);
            });

        return assetChildrenDeferred.promise;
    }

    public getPopulateAssetTree(root?: number, startAtLevel?: number, stopLevel?: number, selectedAsset?: number, appContext?: number) {
        var popTreeDeferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        let myRoot: number
        let strRoot: string = '';
        if (angular.isDefined(root) && root !== null && root >= 0) {
            myRoot = root;
            strRoot = root.toString();
        }
        let myStartAtLevel: number;
        let strStartAtLevel: string = '';
        if (angular.isDefined(startAtLevel) && startAtLevel !== null && startAtLevel >= 0) {
            myStartAtLevel = startAtLevel;
            strStartAtLevel = startAtLevel.toString();
        }
        let myStopLevel: number;
        let strStopLevel: string = '';
        if (angular.isDefined(stopLevel) && stopLevel !== null && stopLevel >= 0) {
            myStopLevel = stopLevel;
            strStopLevel = stopLevel.toString();
        }
        let mySelectedAsset: number;
        let strSelectedAsset: string = '';
        if (angular.isDefined(selectedAsset) && selectedAsset !== null && selectedAsset >= 0) {
            mySelectedAsset = selectedAsset;
            strSelectedAsset = selectedAsset.toString();
        }
        let myAppContext: number;
        let strAppContext: string = '';
        if (angular.isDefined(appContext) && appContext !== null && appContext >= 0) {
            myAppContext = appContext;
            strAppContext = appContext.toString();
        }

        let key = this.getPopulateAssetTreeCacheKey(strRoot, strStartAtLevel, strStopLevel, strSelectedAsset, strAppContext)
        if (angular.isDefined(this.baseModel.storage) && angular.isDefined(this.baseModel.storage[key])) {
            var result = angular.fromJson(this.baseModel.storage[key]);
            popTreeDeferred.resolve(result);
        }
        else {
            this.$http.get<model.IAsset[]>(this.GetUrl("PopulateAssetTree"),
                { 'params': { 'root': myRoot, 'startAtLevel': myStartAtLevel, 'stopLevel': myStopLevel, 'selectedAsset': mySelectedAsset, 'appContext': myAppContext } })
                .then((data) => {
                    this.baseModel.storage[key] = angular.toJson(data.data);
                    popTreeDeferred.resolve(data.data);
                }).catch((err) => {
                    this.LogError("getPopulateAssetTree", err.data);
                    popTreeDeferred.reject(err.data);
                });
        }
        return popTreeDeferred.promise;
    }

    private calcCoeffs(xp1: number, yp1: number,
        xp2: number, yp2: number,
        xp3: number, yp3: number,
        x1: number, y1: number,
        x2: number, y2: number,
        x3: number, y3: number) {
        var result: any = {};

        //Convert to X
        result.ax = -(y1 * (xp3 - xp2) - y2 * xp3 + y3 * xp2 + (y2 - y3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        result.bx = (x1 * (xp3 - xp2) - x2 * xp3 + x3 * xp2 + (x2 - x3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        result.cx = (x1 * (y3 * xp2 - y2 * xp3) + y1 * (x2 * xp3 - x3 * xp2) + (y2 * x3 - x2 * y3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));

        //Convert To Y
        result.ay = -(y1 * (yp3 - yp2) - y2 * yp3 + y3 * yp2 + (y2 - y3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        result.by = (x1 * (yp3 - yp2) - x2 * yp3 + x3 * yp2 + (x2 - x3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        result.cy = (x1 * (y3 * yp2 - y2 * yp3) + y1 * (x2 * yp3 - x3 * yp2) + (y2 * x3 - x2 * y3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));

        return result;
    }

    public getMaps(assetID: number) {
        var deferred: ng.IDeferred<model.IAssetMap[]> = this.$q.defer();

        this.$http.get<model.IAssetMap[]>(this.GetUrl("AssetMaps"), { 'params': { 'assetID': assetID } })
            .then((data) => {
                for (var m of data.data) {
                    //Need to add the url for the image to each map.
                    this.baseModel.getImagePath(m.UniqueID)
                        .then((link) => { m.imagePath = link });
                    m.mapCoeffs = this.calcCoeffs(m.Map_X1, m.Map_Y1,
                        m.Map_X2, m.Map_Y2,
                        m.Map_X3, m.Map_Y3,
                        m.World_Long1, m.World_Lat1,
                        m.World_Long2, m.World_Lat2,
                        m.World_Long3, m.World_Lat3);

                    m.worldCoeffs = this.calcCoeffs(
                        m.World_Long1, m.World_Lat1,
                        m.World_Long2, m.World_Lat2,
                        m.World_Long3, m.World_Lat3,
                        m.Map_X1, m.Map_Y1,
                        m.Map_X2, m.Map_Y2,
                        m.Map_X3, m.Map_Y3);

                    m.getMapCoords = (location) => {
                        var result: any = {};
                        //Map Coordinates  xm = axw + byw + c
                        //                 ym = bxw - ayw + d
                        result.x = m.mapCoeffs.ax * location.Longitude + m.mapCoeffs.bx * location.Latitude + m.mapCoeffs.cx;
                        result.y = m.mapCoeffs.ay * location.Longitude + m.mapCoeffs.by * location.Latitude + m.mapCoeffs.cy;
                        return result;
                    }

                    m.getWorldCoords = (location) => {
                        var result: any = {};
                        //Map Coordinates  xm = axw + byw + c
                        //                 ym = bxw - ayw + d
                        result.longitude = m.worldCoeffs.ax * location.x + m.worldCoeffs.bx * location.y + m.worldCoeffs.cx;
                        result.latitude = m.worldCoeffs.ay * location.x + m.worldCoeffs.by * location.y + m.worldCoeffs.cy;
                        return result;
                    }
                }
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getMaps", err.data)
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetDescendants(assetID: number, levels?: number, includeParent?: boolean, classTypes?: number[], appContextId?: number) {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        this.$http.get<model.IAsset[]>(this.GetUrl("AssetDescendants"),
            {
                'params': {
                    'assetID': assetID,
                    'levels': levels,
                    'includeParent': includeParent,
                    'classTypes': classTypes,
                    'appContextId': appContextId,
                }
            })
            .then((data) => {

                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetDescendants", err.data)
                deferred.reject(err.data);
            });


        return deferred.promise;
    }

    public getDescendants(parentID: number, classTypes: number[], appContextId?: number) {

        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        this.$http.get<model.IAssetAndLocation[]>(this.GetUrl("Descendants"), {
            'params': {
                'parentID': parentID,
                'classTypeID': classTypes,
                'appcontextId': appContextId
            }
        })
            .then((data) => {
                var result: model.IAsset[] = [];
                for (var item of data.data) {
                    var a: any = item.Asset;
                    a.weather = item.CurrentWeather;
                    a.location = item.Location;
                    a.net_MW = item.Net_MW;
                    a.openIssues = item.OpenIssues;
                    a.numSensors = item.NumSensors;
                    a.numTags = item.NumTags;
                    result.push(a);
                }
                deferred.resolve(result);
            })
            .catch((err) => {
                this.LogError("getDescendants", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetClassTypesForAssetDescendants(parentAssetID: number, includeParentAssetType?: boolean, includeAllEntities?: boolean) {
        var deferred: ng.IDeferred<model.IAssetClassType[]> = this.$q.defer();

        this.$http.get<model.IAssetClassType[]>(this.GetUrl("AssetClassTypesForAssetDescendants"), {
            'params': {
                'parentAssetID': parentAssetID,
                'includeParentAssetType': includeParentAssetType,
                'includeAllEntities': includeAllEntities
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetClassTypesForAssetDescendants", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAllDescendantIDs(parentAssetID: number) {
        var deferred: ng.IDeferred<number[]> = this.$q.defer();
        this.$http.get<number[]>(this.GetUrl("GetAllDescendantIDs"), {
            'params': {
                'parentAssetID': parentAssetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAllDescendantIDs", err.data);
                deferred.reject(err.data);
            });
        return deferred.promise;
    }

    public getBranch(assetID: number, stopAtType: number) {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        this.$http.get<model.IAsset[]>(this.GetUrl("Branch"),
            { 'params': { 'assetID': assetID, 'stopAtType': stopAtType } })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getBranch", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetsToNode(assetID: number, includeAsset?: boolean) {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        this.$http.get<model.IAsset[]>(this.GetUrl("Ancestors"),
            {
                'params': {
                    'Id': assetID,
                    'includeAsset': includeAsset
                }
            })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    //This returns an array of arrays.  The top level assets will be the first items in the array
    //and the requested asset will be in the last array in the array.  Each element in the array will
    //be siblings of the others.  
    //var assetToNodeWithSiblingsTimeout; 
    public getAssetToNodeWithSiblings(assetID: number, appContextID?: number) {
        var deferred: ng.IDeferred<model.IAsset[][]> = this.$q.defer();
        if (appContextID == null) {
            appContextID = undefined;
        }

        //If the asset ID is invalid then return nothing. 
        if (!angular.isNumber(assetID) || assetID <= 0) {
            deferred.resolve([]);
        }
        else {
            //Check for the desired asset in the dictionary of assets
            var asset = this.assetDictionary[assetID];
            //Want to ignore the cache if the app context ID is set.  
            if (angular.isUndefined(appContextID) && asset) {
                //It was found so we can create the result from the cached values
                var result = [];

                //Get the parent of the asset to be found so we can get its children 
                var parent = this.assetDictionary[asset.ParentAssetID];

                //loop up the tree 
                while (parent) {
                    //Get the siblings 
                    var kids = this.childrenDictionary[parent.AssetID];

                    //Put the siblings in the result 
                    result.unshift(kids);

                    //Get the parent of the siblings
                    parent = this.assetDictionary[parent.ParentAssetID];

                }
                //The result now has all but the top level set of assets 
                result.unshift(this.childrenDictionary[this.rootNodeID]);

                //Finish!
                deferred.resolve(result);
            }
            else {
                //The asset is not in the asset dictionary, get it from the server. 
                var url = 'api/Assets/AssetsToNodeWithSiblings';

                this.$http.get<model.IAsset[][]>(this.GetUrl("AssetsToNodeWithSiblings"),
                    { 'params': { 'Id': assetID, 'appContextID': appContextID } })
                    .then((data) => {
                        if (data) {
                            //Cycle through the list of lists
                            for (var peers of data.data) {
                                var parentId = peers[0].ParentAssetID;
                                if (!parentId) {
                                    parentId = this.rootNodeID;
                                    peers.forEach((p) => { p.ParentAssetID = this.rootNodeID; })
                                }
                                if (!this.childrenDictionary[parentId] && angular.isUndefined(appContextID)) {
                                    //This assumes that everything that is in the children dictionary is already in the asset dictionary. 
                                    this.childrenDictionary[parentId] = peers;
                                    for (var p of peers) {
                                        this.assetDictionary[p.AssetID] = p;
                                    }
                                }
                            }
                        }
                        deferred.resolve(data.data);
                    })
                    .catch((err) => {
                        var result = "Failed to retrieve assets ";
                        if (angular.isString(err.data)) { result = result + err.data; }
                        else if (err.data) { result = result + (err.data.message || err.data.Message); }
                        this.LogError("getAssetToNodeWithSiblings", err.data);
                        deferred.reject(result);
                    });
            }
        }

        return deferred.promise;
    }

    public getSensors(assetID: number) {
        var deferred: ng.IDeferred<model.IAssetVariableTypeTagMap[]> = this.$q.defer();

        this.$http.get<model.IAssetVariableTypeTagMap[]>(this.GetUrl("Sensors"), {
            'params': {
                'assetId': assetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getSensors", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getSensorData(tagID: number, date1: Date, date2: Date, numPoints: number, queryID?: any) {

        var deferred: ng.IDeferred<model.IDataPointResult> = this.$q.defer();

        this.$http.get<model.IDataPoint[]>(this.GetUrl("SensorData"), {
            'params':
                {
                    'sensorId': tagID,
                    'startDate': date1.toISOString(),
                    'endDate': date2.toISOString(),
                    'numPoints': numPoints
                }
        })
            .then((data) => {
                deferred.resolve({
                    data: data.data, queryID: queryID
                });
            })
            .catch((err) => {
                this.LogError("getSensorData", err.data);
                deferred.reject({
                    'data': err.data, 'queryID': queryID
                });
            });

        return deferred.promise;
    };

    public getAssetAndAncestors(assetID: number) {
        var deferred: ng.IDeferred<model.IAssetInfo> = this.$q.defer();

        if (assetID == null || assetID < 0) {
            deferred.reject({ Message: "No Asset Selected" });
        }
        else {
            this.$http.get<model.IAssetInfo>(this.GetUrl("Asset"), { 'params': { 'assetId': assetID } })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAssetAndAncestors", err.data);
                    deferred.reject(err.data);
                });
        }
        return deferred.promise;
    }

    public getInitialAsset(assetGuid: string, appContext?: string | number) {
        var deferred: ng.IDeferred<model.IAsset> = this.$q.defer();

        if (assetGuid && assetGuid.length >= 36) {
            //We have a potentially valid asset, need to retrieve it. 
            this.getAssetFromGuid(assetGuid, appContext)
                .then((a) => {
                    deferred.resolve(a);
                })
                .catch((e) => {
                    console.error("Could not retrieve asset from id.");
                    console.error(JSON.stringify(e.data));
                    this.getFirstRootAsset(appContext)
                        .then((a) => {
                            deferred.resolve(a);
                        }).catch((e) => {
                            deferred.reject(e);
                        });
                });
        }
        else {
            //No valid asset, need to find the first of the root assets
            this.getFirstRootAsset(appContext)
                .then((a) => {
                    deferred.resolve(a);
                }).catch((e) => {
                    console.error("Could not get the first root asset");
                    deferred.reject(e);
                });
        }

        return deferred.promise;
    }

    public getAssetFromGuid(assetGuid: string, appContext?: string | number) {
        var deferred: ng.IDeferred<model.IAsset> = this.$q.defer();

        if (!assetGuid || assetGuid.length < 36) {
            deferred.resolve(null);
        }
        else {
            var appContextName: string = null;
            var appContextID: number = null;
            if (typeof appContext == "string") {
                appContextName = <string>appContext;
            }
            else if (typeof appContext == "number") {
                appContextID = <number>appContext;
            }

            this.$http.get<model.IAsset>(this.GetUrl("AssetFromGuid"), {
                'params': {
                    'assetGuid': assetGuid,
                    'appContextName': appContextName,
                    'appContextID': appContextID
                }
            })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAssetFromGuid", err.data);
                    deferred.reject(err.data);
                });
        }
        return deferred.promise;
    }

    public isAssetNercCip(assetGuid: string) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        if (!assetGuid || assetGuid.length < 36) {
            deferred.resolve(null);
        }
        else {
            this.$http.get<boolean>(this.GetUrl("IsAssetNerccip"), {
                'params': {
                    'assetGuid': assetGuid
                }
            })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAssetFromGuid", err.data);
                    deferred.reject(err.data);
                });
        }
        return deferred.promise;
    }
    public getFirstRootAsset(appContext?: string | number) {
        var deferred: ng.IDeferred<model.IAsset> = this.$q.defer();

        var appContextName: string = null;
        var appContextID: number = null;
        if (typeof appContext == "string") {
            appContextName = <string>appContext;
        }
        else if (typeof appContext == "number") {
            appContextID = <number>appContext;
        }

        this.$http.get<model.IAsset>(this.GetUrl("FirstRootAsset"), {
            'params': {
                'appContextName': appContextName,
                'appContextID': appContextID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getFirstRootAsset", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }
    public getAssetsByID(assetIDs: number[], appContextID?: number) {
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();

        if (assetIDs === null || assetIDs.length < 1) {
            deferred.resolve([]);
        }
        else {

            this.$http.post<model.IAsset[]>(this.GetUrl("AssetsByID"), assetIDs, {
                'params': {
                    'appContextID': appContextID
                }
            })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAssetsByID", err.data);
                    deferred.reject(err.data);
                });

        }
        return deferred.promise;
    }
    public getAsset(assetID: number | string, appContextID?: number) {
        var deferred: ng.IDeferred<model.IAsset> = this.$q.defer();
        if (appContextID == null) {
            appContextID = undefined;
        }

        if (assetID === null || assetID === undefined) {
            deferred.resolve(null);
        }
        else if (angular.isUndefined(appContextID) && _.isNumber(assetID) && this.assetDictionary[assetID]) {
            deferred.resolve(angular.copy(this.assetDictionary[assetID]));
        }
        else {
            this.$http.get<model.IAssetInfo>(this.GetUrl("Asset"),
                { 'params': { 'assetId': assetID, 'appContextID': appContextID } })
                .then((data) => {
                    var myAss = data.data.Asset;
                    if (angular.isUndefined(appContextID)) {
                        this.assetDictionary[assetID] = angular.copy(myAss);
                    }

                    deferred.resolve(myAss);
                })
                .catch((err) => {
                    var r = "Failed to retrieve asset ";
                    if (angular.isString(err.data)) { r += err.data; }
                    else if (err.data) {
                        r += (err.data.message || err.data.Message);
                    }
                    this.LogError("getAsset", err.data);
                    deferred.reject(r);
                });
        }

        return deferred.promise;
    }

    public getAssetFromCache(assetID) {
        var a = this.assetDictionary[assetID];
        if (a) {
            a = angular.copy(a);
        }
        return a;
    }

    public autoCompleteSearch(search?: string, count?: number, parentID?: number, startAtLevel?: number, stopAtLevel?: number, appContextID?: number) {
        var deferred: ng.IDeferred<model.IAssetAndName[]> = this.$q.defer();

        if (!angular.isDefined(search)) search = '';
        if (!angular.isDefined(count)) count = null;
        if (!angular.isDefined(parentID)) parentID = null;
        if (!angular.isDefined(startAtLevel)) startAtLevel = null;
        if (!angular.isDefined(stopAtLevel)) stopAtLevel = null;

        this.$http.get<model.IAssetAndName[]>(this.GetUrl("AutoCompleteSearch"), {
            'params': {
                'search': search,
                'count': count,
                'parentID': parentID,
                'startAtLevel': startAtLevel,
                'stopAtLevel': stopAtLevel,
                'appContextID': appContextID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("autoCompleteSearch", err.data);
                deferred.reject(err.data);
            });


        return deferred.promise;
    };

    public getAssetGUIDChain(assetGuid: string) {
        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.$http.get<string>(this.GetUrl("AssetGUIDChain"), {
            'params': {
                'assetGuid': assetGuid
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetGUIDChain", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public selectedAssetID(newID?: number) {
        if (typeof newID !== 'undefined') {
            this.selectedAssetIDCache = newID;
            this.baseModel.storage[this.selectedAssetIDCacheKey] = newID;
        }
        return this.selectedAssetIDCache;
    }

    public loadSolarPlant(assetID: number) {
        var deferred: ng.IDeferred<model.ISolarPlantInfo> = this.$q.defer();

        //var calcCoeffs = function (
        //	xp1, yp1,
        //	xp2, yp2,
        //	xp3, yp3,
        //	x1, y1,
        //	x2, y2,
        //	x3, y3) {
        //	//Formula is 
        //	//X' = ax * X + bx * Y + cx
        //	//Y' = ay * X + by * Y + cy

        //	var result = {};

        //	//Convert to X
        //	result.ax = -(y1 * (xp3 - xp2) - y2 * xp3 + y3 * xp2 + (y2 - y3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        //	result.bx = (x1 * (xp3 - xp2) - x2 * xp3 + x3 * xp2 + (x2 - x3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        //	result.cx = (x1 * (y3 * xp2 - y2 * xp3) + y1 * (x2 * xp3 - x3 * xp2) + (y2 * x3 - x2 * y3) * xp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));

        //	//Convert To Y
        //	result.ay = -(y1 * (yp3 - yp2) - y2 * yp3 + y3 * yp2 + (y2 - y3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        //	result.by = (x1 * (yp3 - yp2) - x2 * yp3 + x3 * yp2 + (x2 - x3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));
        //	result.cy = (x1 * (y3 * yp2 - y2 * yp3) + y1 * (x2 * yp3 - x3 * yp2) + (y2 * x3 - x2 * y3) * yp1) / (x1 * (y3 - y2) - x2 * y3 + y2 * x3 + y1 * (x2 - x3));

        //	return result;
        //}

        if (!assetID) {
            deferred.reject({ description: 'No asset selected.' });
        }
        else {

            this.$http.get<model.ISolarPlantModel>(this.GetUrl("SolarPlant"), {
                'params': {
                    'assetID': assetID
                }
            })
                .then((data) => {

                    var myAssets = [];
                    for (var a of data.data.Assets) {
                        a.Asset.Location = a.Location;
                        if (angular.isNumber(a.Net_MW)) {
                            a.Asset.power = a.Net_MW * 1000;
                        }
                        else {
                            a.Asset.power = 0;
                        }
                        a.Asset.openIssues = a.OpenIssues;
                        myAssets.push(a.Asset);
                    }

                    var myMaps = [];
                    for (var m of data.data.Maps) {

                        this.baseModel.getImagePath(m.UniqueID)
                            .then((link) => { m.imagePath = link });

                        m.mapCoeffs = this.calcCoeffs(m.Map_X1, m.Map_Y1,
                            m.Map_X2, m.Map_Y2,
                            m.Map_X3, m.Map_Y3,
                            m.World_Long1, m.World_Lat1,
                            m.World_Long2, m.World_Lat2,
                            m.World_Long3, m.World_Lat3);

                        m.worldCoeffs = this.calcCoeffs(
                            m.World_Long1, m.World_Lat1,
                            m.World_Long2, m.World_Lat2,
                            m.World_Long3, m.World_Lat3,
                            m.Map_X1, m.Map_Y1,
                            m.Map_X2, m.Map_Y2,
                            m.Map_X3, m.Map_Y3);

                        m.getMapCoords = (location) => {
                            var result: any = {};
                            //Map Coordinates  xm = axw + byw + c
                            //                 ym = bxw - ayw + d
                            result.x = m.mapCoeffs.ax * location.Longitude + m.mapCoeffs.bx * location.Latitude + m.mapCoeffs.cx;
                            result.y = m.mapCoeffs.ay * location.Longitude + m.mapCoeffs.by * location.Latitude + m.mapCoeffs.cy;
                            return result;
                        }

                        m.getWorldCoords = (location) => {
                            var result: any = {};
                            //Map Coordinates  xm = axw + byw + c
                            //                 ym = bxw - ayw + d
                            result.longitude = m.worldCoeffs.ax * location.x + m.worldCoeffs.bx * location.y + m.worldCoeffs.cx;
                            result.latitude = m.worldCoeffs.ay * location.x + m.worldCoeffs.by * location.y + m.worldCoeffs.cy;
                            return result;
                        }

                        myMaps.push(m);
                    }

                    var result: model.ISolarPlantInfo = { assets: myAssets, maps: myMaps };

                    deferred.resolve(result);
                })
                .catch((err) => {
                    this.LogError("loadSolarPlant", err.data);
                    deferred.reject(err.data);
                });
        }

        return deferred.promise;
    }

    public getMapInfo(assetID: number) {
        var deferred: ng.IDeferred<model.IAssetMapInfo> = this.$q.defer();

        this.$http.get<model.IAssetMapInfo>(this.GetUrl("GetMapInfo"), {
            'params': {
                'assetId': assetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getMapInfo", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getDataRange(assetID: number, type?: string[]) {
        var deferred: ng.IDeferred<model.IDataRanges> = this.$q.defer();
        this.$http.get<model.IDataRanges>(this.GetUrl("DataRange"), {
            params: {
                assetID: assetID,
                type: type
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getDataRange", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAvailableAttributes(assetClassTypeID: number) {
        var deferred: ng.IDeferred<model.IAttributeTypeWithOptions[]> = this.$q.defer();
        this.$http.get<model.IAttributeTypeWithOptions[]>(this.GetUrl("AvailableAttributes"), {
            params: {
                assetClassTypeID: assetClassTypeID
            }
        })
            .then((data) => {
                for (let myAttribute of data.data) {
                    this.stripOutCrap(myAttribute.AttributeType);
                    for (let myOption of myAttribute.Options) {
                        this.stripOutCrap(myOption);
                    }
                }
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAvailableAttributes", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAvailableAttributesByTypeID(attributeTypeIDs: number[]) {
        var deferred: ng.IDeferred<model.IAttributeTypeWithOptions[]> = this.$q.defer();
        this.$http.post<model.IAttributeTypeWithOptions[]>(this.GetUrl("AvailableAttributesByTypeID"), {
            'IDs': attributeTypeIDs        
        })
        .then((data) => {
            for (let myAttribute of data.data) {
                this.stripOutCrap(myAttribute.AttributeType);
                for (let myOption of myAttribute.Options) {
                    this.stripOutCrap(myOption);
                }
            }
            deferred.resolve(data.data);
        })
        .catch((err) => {
            this.LogError("getAvailableAttributesByTypeID", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }


    public sortAttachments(attachments: model.IAssetAttachment[], sortBy: model.AttachmentSortBy) {
        if (attachments && attachments.length > 1) {
            attachments.sort((a, b) => {
                var result: number;
                if (sortBy == 'custom') {
                    result = a.DisplayOrder - b.DisplayOrder;
                }
                else if (sortBy == 'filename') {
                    result = a.Title.localeCompare(b.Title);
                }
                else if (sortBy == 'caption') {
                    result = a.Caption.localeCompare(b.Caption);
                }
                else if (sortBy == 'date') {
                    result = a.CreateDate.getTime() - b.CreateDate.getTime();
                }
                else if (sortBy == 'date_reverse') {
                    result = b.CreateDate.getTime() - a.CreateDate.getTime();
                }
                if (result == 0) {
                    if (sortBy != 'caption') {
                        result = a.Caption.localeCompare(b.Caption);
                    }
                    else {
                        result = a.CreateDate.getTime() - b.CreateDate.getTime();
                    }
                    if (result == 0) {
                        result = a.AttachmentID.localeCompare(b.AttachmentID);
                    }
                }
                return result;
            });
        }
    }

    private stdAttributeTypesWithOptionsCache: model.IAttributeTypeWithOptions[] = null;
    public getAllStandardAttributeTypesWithOptions(full: boolean = true) {
        var deferred: ng.IDeferred<model.IAttributeTypeWithOptions[]> = this.$q.defer();
        if (!full) {
            deferred.resolve([]);
        }
        else if (this.stdAttributeTypesWithOptionsCache) {
            deferred.resolve(this.stdAttributeTypesWithOptionsCache);
        }
        else {
            this.$http.get<model.IAttributeTypeWithOptions[]>(this.GetUrl("StandardAttributeTypesWithOptions"))
                .then((a) => {
                    for (let myAttribute of a.data) {
                        this.stripOutCrap(myAttribute.AttributeType);
                        for (let myOption of myAttribute.Options) {
                            this.stripOutCrap(myOption);
                        }
                    }
                    this.stdAttributeTypesWithOptionsCache = a.data;
                    deferred.resolve(a.data);
                })
                .catch((ex) => {
                    this.LogError("getAllStandardAttributeTypesWithOptions", ex.data);
                    deferred.resolve([]);
                });
        }
        return deferred.promise;
    }

    public getAssetAndAttributes(assetID: number, full: boolean = true) {
        var deferred: ng.IDeferred<model.IAssetAndAttributes> = this.$q.defer();

        this.getAllStandardAttributeTypesWithOptions(full)
            .then((allTypesWithOptions) => {
                this.$http.get<model.IAssetAndAttributes>(this.GetUrl("AssetAndAttributes"), {
                    params: {
                        assetID: assetID,
                        full: full
                    }
                })
                    .then((data) => {

                        if (data.data.AvailableAttributes) {
                            for (let myAttribute of data.data.AvailableAttributes) {
                                this.stripOutCrap(myAttribute.AttributeType);
                                for (let myOption of myAttribute.Options) {
                                    this.stripOutCrap(myOption);
                                }
                            }
                        }

                        data.data.AllAttributes = allTypesWithOptions;
                        for (let myAttribute of data.data.Attributes) {
                            this.stripOutCrap(myAttribute);
							this.stripOutCrap(myAttribute.AttributeType);
							if (myAttribute.Attribute_date) {
								//Dates are always transmitted as strings.  This will turn them into Date objects if necessary. 
								myAttribute.Attribute_date = new Date(<any>myAttribute.Attribute_date);
							}
						}
                        for (let myAttachment of data.data.Attachments) {
                            this.putFileInfoIntoAttachment(myAttachment.ContentID, myAttachment);
                        }
                        this.sortAttachments(data.data.Attachments, 'custom');
                        for (let aa of data.data.Attachments) {
                            this.convertDatesOnAssetAttachment(aa);
                        }

                        deferred.resolve(data.data);
                    })
                    .catch((err) => {
                        this.LogError("getAssetAndAttributes", err.data);
                        deferred.reject(err.data);
                    });
            });

        return deferred.promise;
    }

    public getAttributesForAssetID(assetID: number) {
        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();
        this.$http.get<model.IAssetAttribute[]>(this.GetUrl("Attributes"), {
            params: {
                assetID: assetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAttributesForAssetID", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetCustomAttributesByContext(assetID: number, context: string) {
        var deferred: ng.IDeferred<model.IAssetProperty[]> = this.$q.defer();
        if (assetID === null || assetID === undefined) {
            deferred.resolve([]);
        }
        else {
            this.$http.get<model.IAssetProperty[]>(this.GetUrl("CustomAttributesByAssetIDAndContext"), {
                params: {
                    assetID: assetID,
                    context: context
                }
            })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError("getAssetCustomAttributesByContext", err.data);
                    deferred.reject(err.data);
                });
        }
        return deferred.promise;
    }
    public getAssetCustomAttributesByContextAndGUID(assetGUID: string, context: string) {
        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();
        this.$http.get<model.IAssetAttribute[]>(this.GetUrl("CustomAttributesByAssetGUIDAndContext"), {
            params: {
                assetGUID: assetGUID,
                context: context
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetCustomAttributes", err.data);
                deferred.reject(err.data);
            });
        return deferred.promise;
    }

    public isContentCategoryCreationAllowed(assetID: number, candidate: string, usage: number) {
        let deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl('ContentCategoryCreationAllowed'), {
            params: {
                assetID: assetID,
                candidate: candidate,
                usage: usage
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError('isContentCategoryCreationAllowed', err.data)
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public isClientContentCategoryCreationAllowed(clientID: number, candidate: string, usage: number) {
        let deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl('ClientContentCategoryCreationAllowed'), {
            params: {
                clientID: clientID,
                candidate: candidate,
                usage: usage
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError('isContentCategoryCreationAllowed', err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public isAssetAttributeAdditionAllowed(assetID: number, candidate: string, usage: number) {
        let deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl('AssetAttributeAdditionAllowed'), {
            params: {
                assetID: assetID,
                candidate: candidate,
                usage: usage
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError('isAssetAttributeAdditionAllowed', err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }


    public getCategorySelections(assetID: number | number[], categoryType: number) {
        let deferred: ng.IDeferred<model.ICategory[]> = this.$q.defer();

        let ids: number[];
        if (_.isArray(assetID)) {
            ids = assetID;
        }
        else {
            ids = [assetID as number];
        }
        ids = _.filter(ids, (n) => { return !_.isNil(n) && n >= 0; });


        if (ids.length <= 0) {
            deferred.resolve([]);
        }
        else {
            this.$http.post<model.ICategory[]>(this.GetUrl('CategorySelections'), { IDs: ids },
                {
                    params: {
                        categoryType: categoryType
                    }
                })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((err) => {
                    this.LogError('getCategorySelections', err.data);
                    deferred.reject(err.data);
                });
        }

        return deferred.promise;
    }

    public getDefaultAttributeCategorySelections(assetID: number, isCustom: boolean, attributeTypeID: number, candidate: string) {
        let deferred: ng.IDeferred<model.ICategory[]> = this.$q.defer();

        this.$http.get<model.ICategory[]>(this.GetUrl('AttributeCategorySelections'), {
            params: {
                assetID: assetID,
                isCustom: isCustom,
                attributeTypeID: attributeTypeID,
                attributeName: candidate
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError('getDefaultAttributeCategorySelections', err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getBranchEquivalentClassTypeAssets(assetID: number, stopAtType: number, classTypeID: number) {
        if (!assetID) {
            assetID = -1;
        }
        var deferred: ng.IDeferred<model.IAsset[]> = this.$q.defer();
        this.$http.get<model.IAsset[]>(this.GetUrl('BranchEquivalentClassTypeAssets'), {
            params: {
                assetID: assetID,
                stopAtType: stopAtType,
                classTypeID: classTypeID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getBranchEquivalentClassTypeAssets", err.data);
                deferred.reject(err.data);
            });
        return deferred.promise;
    }

    public saveAssetAttachment(attachment: model.IAssetAttachment) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.post<boolean>(this.GetUrl("SaveAttachment"), attachment)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("saveAssetAttachment", err);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public saveAssetFull(asset: model.IAssetAndAttributes) {
        let newAsset = angular.copy(asset);

        var deferred: ng.IDeferred<model.IAssetAndAttributes> = this.$q.defer();
        this.$http.post<model.IAssetAndAttributes>(this.GetUrl("SaveAssetFull"), newAsset)
            .then((data) => {
                this.getAssetAndAttributes(newAsset.Asset.AssetID, true)
                    .then((myAsset) => {
                        deferred.resolve(myAsset);
                    })
                    .catch((err) => {
                        this.LogError("saveAssetFull", data);
                        deferred.reject(data);
                    });
            })
            .catch((err) => {
                this.LogError("saveAssetFull", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getSchedulesFlaggedForDelete(mapID?: number, layerID?: number, scheduleChanges?: model.IScheduleInfo[]) {
        var deferred: ng.IDeferred<model.IScheduleInfo[]> = this.$q.defer();

        let parameters: {
            ScheduleMapID: number,
            ScheduleLayerID: number,
            ChangedSchedules: model.IScheduleInfo[]
        } = {
            ScheduleMapID: mapID,
            ScheduleLayerID: layerID,
            ChangedSchedules: scheduleChanges
        };

        this.$http.post<model.IScheduleInfo[]>(this.GetUrl("GetSchedulesFlaggedForDelete"), parameters)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getSchedulesFlaggedForDelete", err.data);
            });

        return deferred.promise;
    }

    public saveAssetListChanges(tagsToAdd: { [key: number]: model.ITaggingKeyword[] }, tagsToDelete: { [key: number]: model.ITaggingKeyword[] },
        attributesToAdd: model.IAssetAttribute[], attributesToDelete: model.IAssetAttribute[], attributesToChange: model.IAssetAttribute[], mapID?:number, layerID?:number, scheduleChanges?:model.IScheduleInfo[]) {
        var deferred: ng.IDeferred<number> = this.$q.defer();

        let myAddedTags: { AssetID: number, Tag: model.ITaggingKeyword }[] = [];
        let myRemovedTags: { AssetID: number, Tag: model.ITaggingKeyword }[] = [];


        for (let id in tagsToAdd) {
            let a = tagsToAdd[id];
            for (let t of a) {
                myAddedTags.push({ AssetID: Number(id), Tag: t });
            }

        }
        for (let id in tagsToDelete) {
            let a = tagsToDelete[id];
            for (let t of a) {
                myRemovedTags.push({ AssetID: Number(id), Tag: t });
            }

        }


        let assetListChanges: {
            AddedTags: { AssetID: number, Tag: model.ITaggingKeyword }[],
            RemovedTags: { AssetID: number, Tag: model.ITaggingKeyword }[],
            AddedAttributes: model.IAssetAttribute[],
            RemovedAttributes: model.IAssetAttribute[],
			ChangedAttributes: model.IAssetAttribute[],
			ScheduleMapID: number,
			ScheduleLayerID: number,
			ChangedSchedules:model.IScheduleInfo[]
        } = {
            AddedTags: myAddedTags,
            RemovedTags: myRemovedTags,
            AddedAttributes: attributesToAdd,
            RemovedAttributes: attributesToDelete,
			ChangedAttributes: attributesToChange,
			ScheduleMapID: mapID,
			ScheduleLayerID: layerID,
			ChangedSchedules: scheduleChanges
            };

        this.$http.post<number>(this.GetUrl("SaveAssetListChanges"), assetListChanges)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
				this.LogError("saveAssetListChanges", err.data);
				deferred.reject("Could not save asset list changes.");
            });

        return deferred.promise;
    }

    public saveAsset(asset: model.IAsset) {
        var deferred: ng.IDeferred<number> = this.$q.defer();
        this.$http.post<number>(this.GetUrl("SaveAsset"), asset
        )
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("saveAsset", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }
    public saveAssetsFull(assets: model.IAssetAndAttributes[]) {
        let assetsToSave: model.IAssetAndAttributes[] = [];
        for (var a of assets) {
            let newAsset = angular.copy(a);
            assetsToSave.push(newAsset);
        }
        var deferred: ng.IDeferred<number[]> = this.$q.defer();
        this.$http.post<number[]>(this.GetUrl("SaveAssetsFull"), assetsToSave
        )
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("saveAssetsFull", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public saveAssets(assets: model.IAsset[]) {
        var deferred: ng.IDeferred<number[]> = this.$q.defer();
        this.$http.post<number[]>(this.GetUrl("SaveAssets"), assets
        )
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("saveAssets", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }
    public deleteAsset(assetID: number) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();
        this.$http.get<boolean>(this.GetUrl("DeleteAsset"), {
            params: {
                assetID: assetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("deleteAsset", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }
    public copyAsset(assetID: number, newParentAssetID: number) {

        var deferred: ng.IDeferred<number> = this.$q.defer();
        this.$http.get<number>(this.GetUrl("CopyAsset"), {
            params: {
                assetID: assetID,
                newParentAssetID: newParentAssetID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("copyAsset", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public possibleParentAssetClassTypes(childAssetClassTypeID: number) {
        var deferred: ng.IDeferred<model.IAssetClassType[]> = this.$q.defer();
        this.$http.get<model.IAssetClassType[]>(this.GetUrl("PossibleParentAssetClassTypes"), {
            params: {
                childAssetClassTypeID: childAssetClassTypeID
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("possibleParentAssetClassTypes", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetClassTypesForAsset(assetId: number, parentAssetClassTypeID: number, childAssetClassTypeIDs: number[]) {

        var deferred: ng.IDeferred<model.IAssetClassType[]> = this.$q.defer();
        this.$http.get<model.IAssetClassType[]>(this.GetUrl("AssetClassTypesForAsset"), {
            params: {
                assetId: assetId,
                parentAssetClassTypeID: parentAssetClassTypeID || 'null',
                childAssetClassTypeID: childAssetClassTypeIDs
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetClassTypesForAsset", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public getAssetClassTypes(parentAssetClassTypeID: number, childAssetClassTypeIDs: number[]) {

        var deferred: ng.IDeferred<model.IAssetClassType[]> = this.$q.defer();
        this.$http.get<model.IAssetClassType[]>(this.GetUrl("AssetClassTypes"), {
            params: {
                parentAssetClassTypeID: parentAssetClassTypeID || 'null',
                childAssetClassTypeID: childAssetClassTypeIDs
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                this.LogError("getAssetClassTypes", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public uploadAsset(attachment: model.IAssetAttachment, file: any, uploadService: any) {
        var deferred: ng.IDeferred<model.IAWSFileUrl> = this.$q.defer();
        //In this situation the method was called to upload a file.   
        let mylink;
        this.baseModel.getFileUrl(null, attachment.Title, true, file.type)
            .then((uplink) => {
                mylink = uplink;
                return this.baseModel.uploadFile(uplink.Url, file);
            }).then(() => {
                return this.baseModel.saveFileInfo(attachment.Title, attachment.AssetID, mylink.ContentID, false);
            }).then((downlink) => {
                deferred.resolve(downlink);
            }).catch((err) => {
                this.LogError("UploadAsset", err);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public putFileInfoIntoAttachment(newFileID: string, data: model.IAssetAttachment) {
        data.complete = true;
        if (data.PreSignedURL) {
            data.path = decodeURIComponent(data.PreSignedURL);
        }
        else {
            if (data.ContentID) {
                data.ContentID = newFileID.replace(/\\|\"/g, '');
                data.path = this.baseModel.getUrl('api/Images/File?id=' + data.ContentID + "&access_token=" + this.baseModel.accessToken());
            }
            else {
                data.path = "";
            }
        }
    }



    private convertDatesOnAssetAttachment(aa: model.IAssetAttachment) {
        aa.CreateDate = new Date(<any>aa.CreateDate);
        aa.ChangeDate = new Date(<any>aa.ChangeDate);
    }

    public createAssetAttachment(assetID: number, title: string, caption: string, favorite: boolean, type: string, file: any, uploadService, displayOrder: number, keywords: model.ITaggingKeyword[], categories: model.ICategory[], link: string = null) {
        var deferred: ng.IDeferred<model.IAssetAttachment> = this.$q.defer();

        let attachmentRequest: model.ICreateAssetAttachmentRequest = {
            AssetID: assetID,
            Title: title,
            Caption: caption,
            Favorite: favorite,
            Type: type,
            DisplayOrder: displayOrder,
            ContentID: null,
            Keywords: keywords,
            Link: link,
            Categories: categories
        };

        this.$http.post<model.IAssetAttachment>(this.GetUrl("CreateAssetAttachment"), attachmentRequest)
            .then((data) => {
                this.convertDatesOnAssetAttachment(data.data);


                if (angular.isDefined(file) && angular.isDefined(uploadService)) {
                    data.data.complete = false;
                    //In this situation the method was called to upload a file. 
                    this.uploadAsset(data.data, file, uploadService)
                        .then((dlink) => {
                            data.data.ContentID = dlink.ContentID;
                            data.data.path = dlink.Url;
                            deferred.resolve(data.data);
                        })
                        .catch((fileUploadError) => {
                            this.LogError("createAssetAttachment", fileUploadError);
                            data.data.uploadError = fileUploadError;
                            deferred.reject(fileUploadError);
                        });
                }
                else {
                    deferred.resolve(data.data);
                }
            }).catch((err) => {
                this.LogError("createAssetAttachment", err.data);
                deferred.reject(err.data);
            });

        return deferred.promise;
    }

    public searchTaggingKeywords(assetID: number | number[], searchExpression: string, limitResultsTo: number) {
        let modelObject = {
            Tag: searchExpression,
            AssetIDs: []
        };

        if (_.isArray(assetID)) {
            modelObject.AssetIDs = assetID;
        }
        else {
            modelObject.AssetIDs.push(assetID);
        }


        var deferred: ng.IDeferred<model.ITaggingKeyword[]> = this.$q.defer();
        this.$http.post<model.ITaggingKeyword[]>(this.GetUrl("SearchTaggingKeywords"), modelObject, {
            'params': {
                'limitResultsTo': limitResultsTo
            }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("SearchTaggingKeywords", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public addTaggingKeyword(assetID: number | number[], text: string) {
        var deferred: ng.IDeferred<model.ITaggingKeyword> = this.$q.defer();

        let modelObject = {
            Tag: text,
            AssetIDs: []
        };

        if (_.isArray(assetID)) {
            modelObject.AssetIDs = assetID;
        }
        else {
            modelObject.AssetIDs.push(assetID);
        }

        this.$http.post<model.ITaggingKeyword[]>(this.GetUrl("AddTaggingKeyword"), modelObject
        ).then((data) => {
            deferred.resolve(data.data[0]);
        }).catch((err) => {
            this.LogError("Add tagging keyword", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public isReservedKeyword(assetID: number | number[], text: string) {

        let modelObject = {
            Tag: text,
            AssetIDs: []
        };

        if (_.isArray(assetID)) {
            modelObject.AssetIDs = assetID;
        }
        else {
            modelObject.AssetIDs.push(assetID);
        }

        var deferred: ng.IDeferred<boolean> = this.$q.defer();
        this.$http.post<boolean>(this.GetUrl("IsReservedKeyword"), modelObject).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("IsReservedKeyword", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public tagAssetAttachment(attachment: model.IKeywordListForTaggedEntity) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.post<any>(this.GetUrl("TagAssetAttachment"), attachment
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("TagAssetAttachment", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;

    }

    public tagDiscussionEntry(discussionEntry: model.IKeywordListForTaggedEntity) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.post<any>(this.GetUrl("TagDiscussionEntry"), discussionEntry
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("TagDiscussionEntry", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;

    }

    public tagAsset(asset: model.IKeywordListForTaggedEntity) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.post<any>(this.GetUrl("TagAsset"), asset
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("TagAsset", err.data);
            deferred.reject(err.data);
        });
        return deferred.promise;

    }

    public searchTaggingKeywordsAdvanced(searchExpression: string, limitResultsTo: number) {
        var deferred: ng.IDeferred<model.ITaggingKeyword[]> = this.$q.defer();
        this.$http.get<model.ITaggingKeyword[]>(this.GetUrl("SearchTaggingKeywordsAdvanced"), {
            'params': {
                'searchExpression': searchExpression,
                'limitResultsTo': limitResultsTo
            }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("SearchTaggingKeywordsAdvanced", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public searchTaggedEntities(searchExpression: string) {
        var deferred: ng.IDeferred<model.ITaggedEntitiesSearchResult> = this.$q.defer();
        this.$http.get<model.ITaggedEntitiesSearchResult>(this.GetUrl("SearchTaggedEntities"), {
            'params': {
                'searchExpression': searchExpression
            }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("SearchTaggedEntities", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public searchBlanketAttributes(assetId: number, searchExpression: string, limit?: number) {
        var deferred: ng.IDeferred<model.IBlanketAttributeDefinition> = this.$q.defer();
        this.$http.get<model.IBlanketAttributeDefinition>(this.GetUrl("SearchBlanketAttributes"), {
            'params': {
                'assetId': assetId,
                'searchExpression': searchExpression,
                'limitResultsTo': limit
            }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("SearchBlanketAttributes", err.data);
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

    public getClientListForCurrentUser() {
        var deferred: ng.IDeferred<number[]> = this.$q.defer();
        this.$http.get<number[]>(this.GetUrl("GetClientList")).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("GetClientList", err.data);
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

    public getClientDetailsListForCurrentUser() {
        var deferred: ng.IDeferred<model.IClientDetailsList> = this.$q.defer();
        this.$http.get<model.IClientDetailsList>(this.GetUrl("GetClientDetailsList")).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("GetClientDetailsList", err.data);
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

    public getTagsAndAttributesSearchSuggestions(searchParams: model.ISearchTaggingKeywordsAndAttributesAdvancedParams) {

        var deferred: ng.IDeferred<string[]> = this.$q.defer();
        this.$http.post<string[]>(this.GetUrl("SearchTaggingKeywordsAndAttributesAdvanced"), searchParams
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("SearchTaggingKeywordsAndAttributesAdvanced", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;

    }

	public listView(searchCriteria: model.IQuickSearchWithResults, serviceCanceller: angular.IDeferred<null> = null) {
		var deferred: ng.IDeferred<model.IQuickSearchWithResults> = this.$q.defer();

		let parameters: model.IQuickSearchWithResults = {
			...searchCriteria,
			Assets: null,
			Attributes: null,
			Schedule: null,
			AssetEvents: null
		};

		parameters.TimesliderSelection = parameters.TimesliderSelection || new Date(); 

		this.$http.post<model.IQuickSearchWithResults>(this.GetUrl("ListView"), parameters, this.getCancellerConfig(null, serviceCanceller))
            .then((data) => {
                if (data && data.data && data.data.Schedule && data.data.Schedule.length > 0) {
                    for (let s of data.data.Schedule) {
                        if (s.Date) {
                            s.Date = new Date(s.Date as any);
                        }

                    }
                }
				deferred.resolve(data.data);
			}).catch((err) => {

				if (this.isCancelled(err)) {
					deferred.reject(null);
				}
				else {
					this.LogError("listView", err.data);
					deferred.reject(err.data || {});
				}
				
			});

		return deferred.promise;
	}

    public advancedSearch(searchCriteria: model.IAdvancedSearchCriteria, pageSize?: number) {
        var deferred: ng.IDeferred<ITaggedEntitiesSearchResult> = this.$q.defer();
        let key = this.getAdvancedSearchCacheKey(searchCriteria, pageSize);
        let cachedItem = this.baseModel.storage[key];
        if (cachedItem) {
            deferred.resolve(JSON.parse(cachedItem));
        }
        else {
            this.$http.post<ITaggedEntitiesSearchResult>(this.GetUrl("AdvancedSearch"), searchCriteria, {
			    'params': {
				    'pageSize': pageSize
			    }
		    }).then((data) => {
                if (data.data.AssetAttachments) {
                    for (var a of data.data.AssetAttachments) {
                        if (a.Path != "") {
                            a.Path = decodeURIComponent(a.Path);
                        }
                        else {
                            if (a.ContentGuid != "") {
                                a.Path = this.baseModel.getUrl('api/Images/File?id=' + a.ContentGuid + "&access_token=" + this.baseModel.accessToken());
                            }
                        }
                    }
                }
                if (data.data.Photos) {
                    for (var a of data.data.Photos) {
                        if (a.Path != "") {
                            a.Path = decodeURIComponent(a.Path);
                        }
                        else {
                            if (a.ContentGuid != "") {
                                a.Path = this.baseModel.getUrl('api/Images/File?id=' + a.ContentGuid + "&access_token=" + this.baseModel.accessToken());
                            }
                        }
                    }
                }
                try {
                    this.baseModel.storage[key] = JSON.stringify(data.data);
                }
                catch (e) {
                    var specific = '';
                    if (e.name) {
                        specific = e.name;
                    }
                    this.LogError("AdvancedSearch unable to cache results: ", specific);
                }
                deferred.resolve(data.data);
            }).catch((err) => {
                this.LogError("AdvancedSearch", err.data);
                deferred.reject(err.data);
            });
        }
        return deferred.promise;
    }

    public gridAdvancedSearch(searchCriteria: model.IAdvancedSearchCriteria, page?: number, pageSize?: number, attributeSortID?: number, sortAsc?: boolean) {
        var deferred: ng.IDeferred<model.ITaggedEntitiesSearchResult> = this.$q.defer();
        this.$http.post<model.ITaggedEntitiesSearchResult>(this.GetUrl("GridAdvancedSearch"), searchCriteria, {
                'params': {
                    'page': page,
                    'pageSize': pageSize,
                    'attributeSortID': attributeSortID,
                    'sortAsc': sortAsc
                }
            }
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("GridAdvancedSearch", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public downloadSearchResultsFile(searchCriteria: model.IAdvancedSearchCriteria) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        var url = 'api/Assets/SearchAndExport';
        var conf = { responseType: 'arraybuffer' };

        this.$http.post<any>(this.GetUrl("SearchAndExport"), searchCriteria, { responseType: 'arraybuffer' })
            .then((data) => {
                var results = { data: null, filename: "" };
                results.data = data.data;
                var headerData = data.headers();
                var filename = headerData['content-disposition'] || 'Results Export.xlsx';
                filename = filename.replace(/['"]+/g, '')
                var pos = filename.lastIndexOf('=');
                if (pos > 0) {
                    results.filename = filename.slice(pos + 1);
                }
                else {
                    results.filename = filename;
                }
                deferred.resolve(results);
            })
            .catch((data) => {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                let obj = {};
                if (decodedString) {
                    obj = JSON.parse(decodedString);
                }
                var error = {
                    Message: obj['Message'],
                    ExceptionMessage: obj['ExceptionMessage']
                };
                deferred.reject(error);
            });
        return deferred.promise;

    }

    public downloadAssetInfoFile(assetID: number) {
        var deferred: angular.IDeferred<{ data: string, filename: string }> = this.$q.defer();
        this.$http.get(this.GetUrl("DownloadAssetInfoFile"), {
            params: {
                assetID: assetID
            },
            responseType: 'arraybuffer'
        })
            .then((data) => {
                var results: any = [];
                results.data = data.data;
                var headerData = data.headers();
                var filename = headerData['content-disposition'] || 'Import Template.xlsx';
                filename = filename.replace(/['"]+/g, '')
                var pos = filename.lastIndexOf('=');
                if (pos > 0) {
                    results.filename = filename.slice(pos + 1);
                }
                else {
                    results.filename = filename;
                }
                deferred.resolve(results);
            })
            .catch((data) => {
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public getAssetBlogSubscribersAndNonSubscribers(assetGuid: string) {
        const deferred: ng.IDeferred<ISubscriber[]> = this.$q.defer();
        this.$http.get<ISubscriber[]>(this.GetUrl("GetAssetBlogSubscribersAndNonSubscribers"), {
            params: { assetGuid }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("GetAssetBlogSubscribersAndNonSubscribers", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
	}
	
	public getAssetBlogSubscribersAndTopics(assetID: number, subscriberUserIDs : number[]) {
		const deferred: ng.IDeferred<{[subscriberUserID: number]: model.IDiscussionAssetMapType[]}> = this.$q.defer();
        this.$http.get<{[subscriberUserID: number]: model.IDiscussionAssetMapType[]}>(this.GetUrl("GetAssetBlogSubscribersAndTopics"), {
            params: { assetID, subscriberUserIDs }
        }).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("GetAssetBlogSubscribersAndTopics", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
	}

    public removeAssetBlogSubscriptions(assetIdAndSubscriberUserIds: model.IAssetBlogSubscriptionData) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.post<any>(this.GetUrl("RemoveAssetBlogSubscriptions"), assetIdAndSubscriberUserIds
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("RemoveAssetBlogSubscriptions", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public addCurrentUserToAssetBlog(assetId: number, discussionAssetType: number) {

		var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.get<any>(this.GetUrl("AddCurrentUserToAssetBlog"), { params: { assetId, discussionAssetType } }
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("AddCurrentUserToAssetBlog", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public addSubscribersToAssetBlog(assetIdAndSubscriberUserIds: model.IAssetBlogSubscriptionData) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.post<any>(this.GetUrl("AddSubscribersToAssetBlog"), assetIdAndSubscriberUserIds
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("AddSubscribersToAssetBlog", err.data);
            deferred.reject(err.data);
        });

        return deferred.promise;
    }

    public unsubscribe(assetGuid: string, discussionAssetType: number) {
        var deferred: ng.IDeferred<any> = this.$q.defer();
        this.$http.get<any>(this.GetUrl('Unsubscribe'), { params: { assetGuid, discussionAssetType } }
        ).then((data) => {
            deferred.resolve(data.data);
        }).catch((err) => {
            this.LogError("Unsubscribe", err.data);
            deferred.reject(err.data);
        });
        return deferred.promise;
    }

    public getGroupMembers(email: string) {

        var getGroupMembersDeferred: angular.IDeferred<model.ISubscriber[]> = this.$q.defer();

        this.$http.get<model.ISubscriber[]>(this.GetUrl('GroupMembers'), { params: { 'email': email } })
            .then((data) => {
                getGroupMembersDeferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("getGroupMembers", data);
                getGroupMembersDeferred.reject(data.data);
            });

        return getGroupMembersDeferred.promise;
    }

    public searchAssetsAndDownload(searchCriteria: model.IAssetSearchCriteria) {

        var deferred: ng.IDeferred<any> = this.$q.defer();
        var url = 'api/Assets/SearchAssetsAndDownload';
        var conf = { responseType: 'arraybuffer' };

        this.$http.post<any>(this.GetUrl("SearchAssetsAndDownload"), searchCriteria, { responseType: 'arraybuffer' })
            .then((data) => {
                var results = { data: null, filename: "" };
                results.data = data.data;
                var headerData = data.headers();
                var filename = headerData['content-disposition'] || 'Results Export.csv';
                filename = filename.replace(/['"]+/g, '')
                var pos = filename.lastIndexOf('=');
                if (pos > 0) {
                    results.filename = filename.slice(pos + 1);
                }
                else {
                    results.filename = filename;
                }
                deferred.resolve(results);
            })
            .catch((data) => {
                var decodedString = String.fromCharCode.apply(null, new Uint8Array(data));
                let obj = {};
                if (decodedString) {
                    obj = JSON.parse(decodedString);
                }
                var error = {
                    Message: obj['Message'],
                    ExceptionMessage: obj['ExceptionMessage']
                };
                deferred.reject(error);
            });
        return deferred.promise;

    }

    public searchAssets(searchCriteria: model.IAssetSearchCriteria) {

        var deferred: ng.IDeferred<any> = this.$q.defer();

        this.$http.post<any>(this.GetUrl("SearchAssets"), searchCriteria, )
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("searchAssets", data);
                deferred.reject(data.data);
            });
        return deferred.promise;

    }

    public culture(asset: string | number) {
        var deferred: ng.IDeferred<string> = this.$q.defer();

        let result = this.baseModel.storage["culture_" + asset];
        if (result) {
            deferred.resolve(result);
        }
        else {
            this.$http.get<string>(this.GetUrl("Culture"), { params: { assetId: asset } })
                .then((data) => {
                    this.baseModel.storage["culture_" + asset] = data.data;
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("culture", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

    public getQuickSearches(assetID: number | string, appContext?: string, tab?: string) {

        var deferred: ng.IDeferred<IQuickSearch[]> = this.$q.defer();

        if (assetID === null || assetID === undefined) {
            deferred.resolve([]);
        }
        else {
            this.$http.get<model.IQuickSearch[]>(this.GetUrl('GetQuickSearches'), { params: { 'asset': assetID, 'ac': appContext, 'tab': tab } })
                .then((data) => {
					angular.forEach(data.data, (qs: model.IQuickSearch) => {
                        let columns = (qs as any).Columns;
                        if ((!qs.QuickSearchColumns || qs.QuickSearchColumns.length == 0) && columns) {
							let colDefs: any[] = JSON.parse(columns);
							qs.QuickSearchColumns = colDefs.map((n, idx) => {
								let r: model.IQuickSearchColumn = {
									AttributeType: null,
									AttributeTypeID: n.Type === 'custom' || n.Type === 'standard' ? parseInt(n.ID) : null,
									AttributeTypeOptions: null,
									DateFilterMax: null,
									DateFilterMin: null,
									DisplayOrder: idx,
									FilterString: null,
									QuickSearchColumnID: null,
									QuickSearchID: null,
									ScheduleID: n.Type === 'actual' || n.Type === 'plan' ? parseInt(n.ID) : null,
									ScheduleType: n.Type === 'actual' || n.Type === 'plan' ? n.Type : null,
									EventAssetClassTypeID: null,
									EventAttributeTypeID: null,
									Sort: null,
									IsBuiltin: this.isBuiltin(n.Name),
									Title:n.Name
								};
								return r;
							});
                        }
                        if (!qs.ScheduleMapID && qs.SelectedMapGeoSpaID) { // old search format - populate new column
                            qs.ScheduleMapID = qs.SelectedMapGeoSpaID;
                        }
                        if (!qs.ScheduleAssetClassTypeID && qs.AssetClassTypeID) { // this conditional will probably not ever be true - if ScheduleAssetClassTypeID is missing (old searches where it was not a saved property)
                            qs.ScheduleAssetClassTypeID = qs.AssetClassTypeID;     // it will be filled from the default map layer selected during ExecuteListView() in the AssetController
                        }                                                          // NOTE this may not be the correct ACT if there are multiple for the map - these cases will have to be corrected manually in the interface / database / script
                                                                                   // worst case scenario is blank schedule column data for a search 
                        if (qs.TimesliderSelection && angular.isString(qs.TimesliderSelection)) {
                            qs.TimesliderSelection = BVUtils.GetDate(qs.TimesliderSelection);
                        }
                        if (qs.StatusChangeLogEndDate && angular.isString(qs.StatusChangeLogEndDate)) {
                            qs.StatusChangeLogEndDate = BVUtils.GetDate(qs.StatusChangeLogEndDate);
                        }
                        if (qs.StatusChangeLogStartDate && angular.isString(qs.StatusChangeLogStartDate)) {
                            qs.StatusChangeLogStartDate = BVUtils.GetDate(qs.StatusChangeLogStartDate);
                        }
                    });
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("GetQuickSearches", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

		public isBuiltin(name: string) {
			var nameLowerCase = name.toLowerCase();
			return nameLowerCase === 'asset' || nameLowerCase === 'asset type' || nameLowerCase === 'class' || nameLowerCase === 'path' || nameLowerCase === 'tags' ? true : false;
		}
		
    public deleteQuicksearch(quickSearchId: number) {

        var deferred: ng.IDeferred<any> = this.$q.defer();

        this.$http.get<any>(this.GetUrl('DeleteQuicksearch'), { params: { 'quickSearchId': quickSearchId } })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("GetQuickSearches", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public saveQuicksearch(quickSearch: model.IQuickSearch) {

        var deferred: ng.IDeferred<IQuickSearch> = this.$q.defer();

        this.$http.post<IQuickSearch>(this.GetUrl("SaveQuicksearch"), quickSearch, )
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("saveQuicksearch", data);
                deferred.reject(data.data);
            });
        return deferred.promise;

    }

    public GetAssetWithAttribute(assetID: number, attributeID?: number, attributeKey?: string, includeAncestors?: boolean, includeSelf?: boolean, includeStandardAttributes?: boolean, includeCustomAttributes?: boolean) {

        var deferred: ng.IDeferred<{ Asset: model.IAsset, Attribute: model.IAssetAttribute, CustomAttribute: model.IAssetAttribute }> = this.$q.defer();

        this.$http.get<{ Asset: model.IAsset, Attribute: model.IAssetAttribute, CustomAttribute: model.IAssetAttribute }>(this.GetUrl('AssetWithAttribute'), {
            params: {
                'assetID': assetID,
                'attributeID': attributeID,
                'attributeKey': attributeKey,
                'includeAncestors': includeAncestors,
                'includeSelf': includeSelf,
                'includeStandardAttributes': includeStandardAttributes,
                'includeCustomAttributes': includeCustomAttributes,
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("AssetWithAttribute", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public GetStandardAttributeForAssets(assets: number[], attribute?: number) {
        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();

        if (!assets || assets.length == 0) {
            deferred.resolve([]);
        }
        else {
            this.$http.post<model.IAssetAttribute[]>(this.GetUrl('StandardAttributeForAssets'), { 'IDs': assets }, {
                params: {
                    'attribute': attribute
                }
            })
                .then((data) => {
                    for (let d of data.data) {
                        this.stripOutCrap(d.AttributeType);
                    }
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("GetStandardAttributeForAssets", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

    // gets the minified attributes for assets
    public GetAttributesForAssetSmall(assets: number[]) {
        var deferred: ng.IDeferred<model.IAssetAttributesSmall> = this.$q.defer();

        if (!assets || assets.length == 0) {
            deferred.resolve(null);
        }
        else {
            this.$http.post<model.IAssetAttributesSmall>(this.GetUrl('AttributesForAssetSmall'), { 'IDs': assets },)
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("GetAttributesForAssetSmall", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

	//This exists as a result of the unification of the standard and custom assets.  Previously the custom attributes
	//were represented with an IAssetProperty object.  When we unified the two the IAssetProperty was no longer necessary,
	//but some apps were still using it. This allows us to not rewrite those apps.  
	public toAssetProperty(items: model.IAssetAttribute[]): model.IAssetProperty[] {
		return items.map(n => {
			let m: model.IAssetProperty;
			m = {
				AssetCustomAttributeID: n.AssetAttributeID,
				AssetID: n.AssetID,
				ChangeDate: n.ChangeDate,
				ChangedBy: n.ChangedBy,
				Context: "",
				CreateDate: n.CreateDate,
				CreatedBy: n.CreatedBy,
				Name: n.AttributeType.AttributeTypeDesc,
				Value: BVUtils.AttributeValue(n),
				Favorite: n.Favorite,
				DisplayOrder: n.DisplayOrder,
				IsTheOwner: n.IsTheOwner,
				Categories: n.Categories
			};
			return m; 
		});
	}

    public GetAttributesForAssets(assets: (string | number)[], attributes?: (string | number)[]) {
        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();

		attributes = attributes || []; 

        if (!assets || assets.length == 0) {
            deferred.resolve([]);
        }
        else {
			this.$http.post<model.IAssetAttribute[]>(this.GetUrl('AttributesForAssets'), { 'assets': assets, 'attributes': attributes })
                .then((data) => {
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("AttributesForAssets", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

    public GetCustomAttributeForAssets(assets: number[], attributes: string[]) {

        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();

        if (!assets || assets.length == 0) {
            deferred.resolve([]);
        }
        else {
            this.$http.post<model.IAssetAttribute[]>(this.GetUrl('CustomAttributeForAssets'), { 'assets': assets, 'attributes': attributes })
                .then((data) => {
                    for (let d of data.data) {
                        this.stripOutCrap(d.AttributeType);
                    }
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("GetCustomAttributeForAssets", data);
                    deferred.reject(data.data);
                });
        }
        return deferred.promise;
    }

    public GetCustomAttributeForAssetsIncludeAncestry(assets: number[], attributes: string[]) {

        var deferred: ng.IDeferred<model.IAssetAttribute[]> = this.$q.defer();

        this.$http.post<model.IAssetAttribute[]>(this.GetUrl('CustomAttributeForAssets'), { 'assets': assets, 'attributes': attributes }, {
            params: {
                'includeAncestorsAndSelf': true
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("GetCustomAttributeForAssetsIncludeAncestry", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public GetAttachmentPopupLink(attachment: model.IAssetAttachment) {

        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.$http.get<string>(this.GetUrl('AttachmentPopupLink'), {
            params: {
                'attachmentId': attachment.AttachmentID,
                'contentId': attachment.ContentID
            }
        })
            .then((data) => {
                deferred.resolve(decodeURIComponent(data.data));
            })
            .catch((data) => {
                this.LogError("GetAttachmentPopupLink", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public GetAttachmentPopupLinkFromIDs(attachmentID: string, contentID: string) {

        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.$http.get<string>(this.GetUrl('AttachmentPopupLink'), {
            params: {
                'attachmentId': attachmentID,
                'contentId': contentID
            }
        })
            .then((data) => {
                deferred.resolve(decodeURIComponent(data.data));
            })
            .catch((data) => {
                this.LogError("GetAttachmentPopupLinkFromIDs", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }


    public saveCustomAttributeData(custAttr: model.IAssetAttribute) {
        var deferred: ng.IDeferred<any> = this.$q.defer();

        this.$http.post<any>(this.GetUrl("SaveCustomAttributeData"), custAttr)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError('saveCustomAttributeData', data);
                deferred.reject(data.data);
            });
        return deferred.promise;

    }

    public clientAccessRoleExists(assetId: number) {
        let deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl('AssetAccessRoleExists'), {
            params: {
                'assetId': assetId
            }
        })
            .then((result) => {
                deferred.resolve(result.data);
            })
            .catch((result) => {
                this.LogError('clientAccessRoleExists', result);
                deferred.reject(result.data);
            });

        return deferred.promise;
    }

    public createClientAccessRole(assetId: number) {
        let deferred: ng.IDeferred<model.ICreateClientAccessRoleResult> = this.$q.defer();

        this.$http.get<model.ICreateClientAccessRoleResult>(this.GetUrl('AssetAccessRole'), {
            params: {
                'assetId': assetId
            }
        })
            .then((result) => {
                deferred.resolve(result.data);
            })
            .catch((result) => {
                this.LogError('createClientAccessRole', result);
                deferred.reject(result.data);
            });

        return deferred.promise;
    }

    public getNewAssetHierarchySyncAWSSQSJob(assetId: number, jobName: string) {
        var deferred: ng.IDeferred<atxjobs.IAssetHierarchySyncAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.IAssetHierarchySyncAWSSQSJob>(this.baseModel.getUrl('api/Assets/CreateAssetHierarchySyncJob'), {
            'params': {
                selectedAssetId: assetId,
                jobName: jobName
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('getNewAssetHierarchySyncAWSSQSJob', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public queueAssetHierarchySyncJob(jobExtId: string) {
        var deferred: ng.IDeferred<atxjobs.IAssetHierarchySyncAWSSQSJob> = this.$q.defer();

        this.$http.get<atxjobs.IAssetHierarchySyncAWSSQSJob>(this.baseModel.getUrl('api/Assets/QueueAssetHierarchySyncJob'), {
            'params': {
                jobExtId: jobExtId
            }
        })
            .then((result: any) => {
                deferred.resolve(result.data);
            })
            .catch((error: any) => {
                this.LogError('queueAssetHierarchySyncJob', error);
                deferred.reject(error.data);
            });

        return deferred.promise;
    }

    public getAttributeOptionsOrphans(attributeTypeID: number, options: string[]) {
        var deferred: ng.IDeferred<model.IAttributeTypeOption[]> = this.$q.defer();
        this.$http.get<model.IAttributeTypeOption[]>(this.GetUrl('GetAttributeOptionsOrphans'), {
            params: {
                'options': options, 
                'attributeTypeID': attributeTypeID
            }
        })
        .then((data) => {
            deferred.resolve(data.data);
        })
        .catch((data) => {
            this.LogError("GetAttributeOptionsOrphans", data);
            deferred.reject(data.data);
        });
        return deferred.promise;
    }

    public getAttributeOptions(attributeTypeIDs: number[]) {
        var deferred: ng.IDeferred<model.IAttributeTypeOption[]> = this.$q.defer();
        this.$http.post<model.IAttributeTypeOption[]>(this.GetUrl('GetAttributeOptions'), {
                'IDs': attributeTypeIDs
        })
            .then((data) => {
                for (let myOption of data.data) {
                    this.stripOutCrap(myOption);
                }
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("GetAttributeOptions", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
	}

	public canEditAsset(assetID) {
		return this.canEditAssets([assetID]).then((val) => {
			return val[0].canEdit;
		})
	}

	public canEditAssets(assetIDs: number[]) {
		var deferred: ng.IDeferred<{ assetID: number, canEdit: boolean }[]> = this.$q.defer();

		deferred.resolve(assetIDs.map(n => { return { assetID: n, canEdit: true } }));

		return deferred.promise;
    }

	public getAttributeTypesForAssets(assetIDs: number[]) {
		var deferred: ng.IDeferred<model.IAttributeType[]> = this.$q.defer();
		this.$http.post<model.IAttributeType[]>(this.GetUrl('AttributeTypesForAssets'), { 'IDs': assetIDs })
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getAttributeTypesForAssets", data);
				deferred.reject(data.data);
			});
		return deferred.promise;
	}

    public getAttrTypesAndCategories(assetIDs: number[]) {
        var deferred: ng.IDeferred<model.IColumnInfo[]> = this.$q.defer();
		this.$http.post<model.IColumnInfo[]>(this.GetUrl('AttrTypesAndCategories'), { 'IDs': assetIDs })
        .then((data) => {
            deferred.resolve(data.data);
        })
        .catch((data) => {
            this.LogError("getAttrTypesAndCategories", data);
            deferred.reject(data.data);
        });
        return deferred.promise;
    }

    public getEventTypesAndAttributes(assetIDs: number[]) {
        var deferred: ng.IDeferred<model.IEventTypesAndAttrs> = this.$q.defer();
        this.$http.post<model.IEventTypesAndAttrs>(this.GetUrl('EventTypesAndAttributes'), { 'IDs': assetIDs })  
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("getEventTypesAndAttributes", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

	public ExportListViewContents(searchCriteria: model.IQuickSearchWithResults) {
		var deferred: angular.IDeferred<{ data: string, filename: string }> = this.$q.defer();

		let parameters: model.IQuickSearchWithResults = {
			...searchCriteria,
			Assets: null,
			Attributes: null,
			Schedule: null,
			AssetEvents: null
		};

		this.$http.post(this.GetUrl("ExportListViewContents"), parameters, {
			responseType: 'arraybuffer'
		})
			.then((data) => {
				var results: any = [];
				results.data = data.data;
				var headerData = data.headers();
				var filename = headerData['content-disposition'] || 'ListExport.xlsx';
				filename = filename.replace(/['"]+/g, '')
				var pos = filename.lastIndexOf('=');
				if (pos > 0) {
					results.filename = filename.slice(pos + 1);
				}
				else {
					results.filename = filename;
				}
				deferred.resolve(results);
			})
			.catch((data) => {
				deferred.reject(data.data);
			});
		return deferred.promise;
    }

    public grandChildrenTilesAreHidden(assetID: number) {
        let deferred: ng.IDeferred<boolean> = this.$q.defer();

        this.$http.get<boolean>(this.GetUrl('GrandChildrenTilesAreHidden'),
            {
                'params': {
                    'assetId': assetID
                }
            })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((err) => {
                deferred.reject(err.data);
            });

        return deferred.promise;
    }
}

modelModule.factory('assetsModel', ['$http', '$q', '$log', 'baseModel', ($http, $q, $log, baseModel) => new AssetsModel($http, $q, $log, baseModel)]);


// WEBPACK FOOTER //
// ./Common/Models/AssetsModel.ts